import { useAuth } from '@ben/shared/providers/auth-provider';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { EmployerMe } from '../../api/ecc/me';
import { getEmployerMe } from '../../api/ecc/me';
import { createInvalidateHook, createSetQueryHook } from './use-query-base';

const QUERY_KEY = 'employerMe';

const getKey = () => {
  return [QUERY_KEY];
};

export const useQueryEmployerMe = (
  options?: Omit<UseQueryOptions<EmployerMe>, 'queryKey' | 'queryFn'>
) => {
  const { isAuthenticated } = useAuth();
  return useQuery<EmployerMe>({
    ...options,
    enabled: isAuthenticated && options?.enabled !== false,
    queryKey: getKey(),
    queryFn: getEmployerMe,
  });
};

export const useInvalidateEmployerMe = createInvalidateHook(getKey);

export const useSetQueryEmployerMe = createSetQueryHook<undefined, EmployerMe>(
  getKey
);
